import { useEffect } from 'react';
import { StatusPill } from '@/components/common/StatusPill';
import { MyApprovalStatusFilters } from '@/features/my-approval-status/components/MyApprovalStatusFilters';
import { MyApprovalStatusSummary } from '@/features/my-approval-status/components/MyApprovalStatusSummary';
import { MyApprovalStatusTable } from '@/features/my-approval-status/components/MyApprovalStatusTable';
import { useMyApprovalStatusData } from '@/features/my-approval-status/useMyApprovalStatusData';

export function MyApprovalStatusSection({ refreshKey = 0 }) {
  const {
    loading,
    rowsLoading,
    error, clearError,
    activeTab,
    rows,
    counts,
    summary,
    totalRows,
    hasMoreRows,
    filters,
    updateFilters,
    setActiveTab,
    resetFilters,
    refresh
  } = useMyApprovalStatusData();

  useEffect(() => {
    if (refreshKey > 0) {
      refresh();
    }
  }, [refreshKey, refresh]);

  return (
    <div className="my-approval-status-section">
      {error ? (
        <div className="dashboard-banner dashboard-banner--error">
          <span>{error}</span>
          <button type="button" className="dashboard-banner__close" onClick={clearError}>OK</button>
        </div>
      ) : null}

      {!error && loading ? (
        <div className="dashboard-banner">
          <StatusPill tone="info">Refreshing</StatusPill>
          <span>Loading your approval history...</span>
        </div>
      ) : null}

      <MyApprovalStatusSummary summary={summary} />
      <MyApprovalStatusFilters
        activeTab={activeTab}
        counts={counts}
        filters={filters[activeTab]}
        onTabChange={setActiveTab}
        onChange={(patch) => updateFilters(activeTab, patch)}
        onReset={() => resetFilters(activeTab)}
      />
      <MyApprovalStatusTable rows={rows} loading={rowsLoading} totalRows={totalRows} hasMoreRows={hasMoreRows} />
    </div>
  );
}
